import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { gql } from '../../graphql/client';
import { Q_LIST_PACKAGES } from '../../graphql/operations';
import type { AppPackage } from '../../types/forge';

import { createAppPackage } from './packagingService';

export function PackagingControls({ appId }: { appId: string }) {
  const queryClient = useQueryClient();
  const [version, setVersion] = useState('');
  const [error, setError] = useState<string | null>(null);

  const packages = useQuery({
    queryKey: ['packages', appId],
    queryFn: () => gql<{ app_package: AppPackage[] }>(Q_LIST_PACKAGES, { appId }),
  });

  const create = useMutation({
    mutationFn: () =>
      createAppPackage({ appId, version, packageName: `package-${version}`, platformVersion: '0.2.0' }),
    onSuccess() {
      setVersion('');
      setError(null);
      queryClient.invalidateQueries({ queryKey: ['packages', appId] });
    },
    onError(err) {
      setError(err instanceof Error ? err.message : String(err));
    },
  });

  const recent = packages.data?.app_package?.[0];

  return (
    <div style={styles.bar}>
      <input
        value={version}
        onChange={(e) => setVersion(e.target.value)}
        placeholder="0.1.0"
        style={styles.input}
      />
      <button
        onClick={() => version.trim() && create.mutate()}
        disabled={!version.trim() || create.isPending}
        style={styles.btn}
      >
        {create.isPending ? 'Packaging…' : 'Create package'}
      </button>
      {recent && (
        <span style={styles.recent}>
          Latest: <strong>{recent.version}</strong>
        </span>
      )}
      {error && <span style={styles.error}>{error}</span>}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: { display: 'flex', alignItems: 'center', gap: 8 },
  input: { width: 90, padding: '6px 8px', fontSize: 12, border: '1px solid #CBD5E1', borderRadius: 4 },
  btn: {
    padding: '6px 10px', fontSize: 12, fontWeight: 600, color: '#fff',
    backgroundColor: '#10B981', border: 'none', borderRadius: 6, cursor: 'pointer',
  },
  recent: { fontSize: 11, color: '#64748B' },
  error: { fontSize: 11, color: '#991B1B' },
};
